import CitySEOHead from "@/components/feature/CitySEOHead";
import AlbuquerqueHeroSection from "./components/HeroSection";
import AlbuquerqueStickyNav from "./components/StickyNav";
import AlbuquerqueProcessingTimeSection from "./components/ProcessingTimeSection";
import AlbuquerqueServicesSection from "./components/ServicesSection";
import AlbuquerqueLocalAreaSection from "./components/LocalAreaSection";
import AlbuquerqueTestimonialsSection from "./components/TestimonialsSection";
import AlbuquerqueAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AlbuquerqueComparisonSection from "./components/ComparisonSection";
import AlbuquerqueMistakesSection from "./components/MistakesSection";
import AlbuquerqueHowItWorksSection from "./components/HowItWorksSection";
import AlbuquerqueFAQSection, { faqs } from "./components/FAQSection";
import AlbuquerqueHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AlbuquerqueFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import AlbuquerqueTravelTimingSection from "./components/TravelTimingSection";
import AlbuquerqueDestinationsSection from "./components/DestinationsSection";

const albuquerqueFaqs = faqs as { q: string; a: string }[];

const albuquerqueServices = [
  { name: "Emergency Passport", description: "Kirtland AFB deployment orders came through? Sandia Labs engineer with a last-minute conference abroad? As fast as 24 hours with reserved agency submission." },
  { name: "Passport Renewal", description: "Fast renewal for Albuquerque professionals, UNM faculty, and Rio Grande Valley families — ship overnight from any ABQ FedEx or UPS." },
  { name: "New Passport", description: "First-time applicants — UNM students, new New Mexico residents, Kirtland families — guided through every step with a clear checklist." },
  { name: "Lost or Stolen Passport", description: "DS-64 and DS-11 guidance so Albuquerque travelers can replace lost passports on the fastest possible timeline." },
  { name: "Child Passport", description: "Minors require parental participation and in-person acceptance. Clear instructions for Albuquerque and Bernalillo County families." },
  { name: "Name Change", description: "Post-marriage, divorce, or legal name change — corrected passports for Albuquerque residents." },
  { name: "Second Passport", description: "Need a second passport for frequent international travel? Ideal for Sandia Labs researchers, defense contractors, and UNM professors who travel while their primary passport is in visa processing." },
  { name: "Damaged Passport", description: "Replacing a significantly damaged passport is faster than you think. We guide you through the process so your international itinerary stays on track." },
  { name: "Passport Card", description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Same expedited processing as book passports." },
];

export default function AlbuquerquePage() {
  return (
    <>
      <CitySEOHead
        city="Albuquerque"
        state="New Mexico"
        stateAbbr="NM"
        route="/cities/albuquerque"
        title="Emergency Passport Albuquerque, NM — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Albuquerque, NM — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Kirtland AFB military families, Sandia Labs professionals, UNM students, and cross-border family travelers."
        geoPlacename="Albuquerque, New Mexico"
        geoPosition="35.0844;-106.6504"
        faqs={albuquerqueFaqs}
        servicesSchema={albuquerqueServices}
        statePageName="New Mexico"
        statePageRoute="/states/new-mexico"
        areaServedList={[
          { "@type": "City", name: "Albuquerque" },
          { "@type": "City", name: "Rio Rancho" },
          { "@type": "City", name: "Los Lunas" },
          { "@type": "City", name: "Corrales" },
          { "@type": "City", name: "Bernalillo" },
          { "@type": "City", name: "Santa Fe" },
          { "@type": "AdministrativeArea", name: "Bernalillo County" },
        ]}
        serviceAreaDesc="Fast Passport Center is a registered U.S. Department of State passport courier serving Albuquerque, Rio Rancho, Los Lunas, Corrales, Santa Fe, and all of Bernalillo County with expedited passport processing as fast as 24 hours. A+ BBB rated. Remote service — all business conducted by mail/overnight courier from our Phoenix office at 4742 N 24th St."
      />
      <div className="font-sans">
        <AlbuquerqueHeroSection />
        <AlbuquerqueStickyNav />
        <AlbuquerqueProcessingTimeSection />
        <AlbuquerqueLocalAreaSection />
        <AlbuquerqueServicesSection />
        <AlbuquerqueTravelTimingSection />
        <AlbuquerqueDestinationsSection />
        <AlbuquerqueTestimonialsSection />
        <AlbuquerqueAcceptanceFacilitiesSection />
        <AlbuquerqueComparisonSection />
        <AlbuquerqueMistakesSection />
        <AlbuquerqueHowItWorksSection />
        <AlbuquerqueFAQSection />
        <AlbuquerqueHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/albuquerque" state="NM" />
        <AlbuquerqueFinalCTA />
      </div>
    </>
  );
}